/**
 * Created by Rodrigo Quesada on 09/03/17.
 */
import {FileHelper} from '../../../../components/files/helper/file-helper.class';

export class FileInfo {
    readonly id: string;
    readonly remoteId: string;
    readonly originalFilename: string;
    readonly extension: string;
    readonly size: number;

    readonly sizeKb: string;

    private readonly _fileHelper = new FileHelper();

    constructor(jsonData: any = {}) {
        Object.assign(this, jsonData);
        this.sizeKb = this._fileHelper.formatSize(this.size);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/common/file/file-info.class.ts